// import { useAuth0 } from "@auth0/auth0-react";

// import React, { useState } from "react";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import Cart from "./component/Cart";
// import SignIn from "./component/SignIn";
// import { Toaster } from "react-hot-toast";
// import Home from "./component/Home";
// import Navbar from "./component/Navbar";
// import Contact from "./component/Contact";

// import { CartProvider } from "react-use-cart";
// import Footer from "./component/Footer";
// import StoryofWaste from "./component/AboutUS/StoryofWaste";
// import VisionMission from "./component/AboutUS/VisionMission";
// import DoortoDoor from "./component/Products/DoortoDoor";
// import Weighbridge from "./component/Products/Weighbridge";
// import BinMonitoring from "./component/Products/BinMonitoring";
// import VehicleMonitoring from "./component/Products/VehicleMonitoring";
// import EmployeeManagement from "./component/Products/EmployeeManagement";
// import AIWasteManagement from "./component/Products/AIWasteManagement";
// import SwachhAJV from "./component/Platform/SwachhAJV";
// import CaseStudies from "./component/Resources/CaseStudies";
// import Datasheet from "./component/Resources/Datasheet";
// import Videos from "./component/Resources/Videos";
// import Brochure from "./component/Resources/Brochure";
// import Gallery from "./component/Resources/Gallery";
// import Blogs from "./component/Resources/Blogs";
// import Podcast from "./component/Resources/Podcast";
// import SwachhAJVShop from "./component/Resources/SwachhAJVShop";
// import SmartBins from "./component/Resources/AllBlogs/SmartBins";
// import AIWasteSegregation from "./component/Resources/AllBlogs/AIWasteSegregation";
// import WasteManagementPolicy from "./component/Resources/AllBlogs/WasteManagementPolicy";
// import DigitalWasteTracking from "./component/Resources/AllBlogs/DigitalWasteTracking";
// import AutomatedWasteSorting from "./component/Resources/AllBlogs/AutomatedWasteSorting";
// import OfferingGeoTrackingVehicles from "./component/Resources/AllBlogs/OfferingGeoTrackingVehicles";
// import OfferingSmartSegregation from "./component/Resources/AllBlogs/OfferingSmartSegregation";
// import OfferingGrievanceRedressal from "./component/Resources/AllBlogs/OfferingGrievanceRedressal";
// import OfferingDataDrivenInsights from "./component/Resources/AllBlogs/OfferingDataDrivenInsights";
// import OfferingRouteOptimization from "./component/Resources/AllBlogs/OfferingRouteOptimization";

// function App() {
//   return (
//     <>
//       <CartProvider>
//         <Router>
//           <div>
//             <Toaster />
//             <Navbar />
//             <Routes>
//               <Route path="/" element={<Home />} />
//               <Route path="/story-of-waste" element={<StoryofWaste />} />
//               <Route path="/vision-mission" element={<VisionMission />} />
//               <Route path="/door-to-door-collection" element={<DoortoDoor />} />
//               <Route path="/weighbridge" element={<Weighbridge />} />
//               <Route path="/bin-monitoring" element={<BinMonitoring />} />
//               <Route path="/vehicle-monitoring" element={<VehicleMonitoring />} />
//               <Route path="/employee-management" element={<EmployeeManagement />} />
//               <Route path="/ai-waste-management" element={<AIWasteManagement />} />
//               <Route path="/swachhajv" element={<SwachhAJV />} />
//               <Route path="/case-studies" element={<CaseStudies />} />
//               <Route path="/datasheet" element={<Datasheet />} />
//               <Route path="/videos" element={<Videos />} />
//               <Route path="/brochure" element={<Brochure />} />
//               <Route path="/gallery" element={<Gallery />} />
//               <Route path="/blogs" element={<Blogs />} />
//               <Route path="/podcast" element={<Podcast />} />
//               <Route path="/shop" element={<SwachhAJVShop />} />
//               <Route path="/contact" element={<Contact />} />
//               <Route path="/cart" element={<Cart />} />
//               <Route path="/signin" element={<SignIn />} />
//               <Route path="/blog/how-iot-is-revolutionizing-waste-collection" element={<SmartBins />} />
//               <Route path="/blog/aipowered-waste-segregation-explained" element={<AIWasteSegregation />} />
//               <Route path="/blog/policy-changes-shaping-waste-management" element={<WasteManagementPolicy />} />
//               <Route path="/blog/tracking-waste-digitally" element={<DigitalWasteTracking />} />
//               <Route path="/blog/automation-in-waste-sorting" element={<AutomatedWasteSorting />} />
//               <Route path="/geo-tracking" element={<OfferingGeoTrackingVehicles />} />
//               <Route path="/smart-segregation" element={<OfferingSmartSegregation />} />
//               <Route path="/grievance-redressal" element={<OfferingGrievanceRedressal />} />
//               <Route path="/data-insights" element={<OfferingDataDrivenInsights />} />
//               <Route path="/route-optimization" element={<OfferingRouteOptimization />} />
//             </Routes>
//             <Footer/>
//           </div>
//         </Router>
//       </CartProvider>
//     </>
//   );
// }

// export default App;

// My code implementation no-layout for signin and register page....

import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Cart from "./component/Cart";
import SignIn from "./component/SignIn";
import { Toaster } from "react-hot-toast";
import Home from "./component/Home";
import Navbar from "./component/Navbar";
import Contact from "./component/Contact";
import { CartProvider } from "react-use-cart";
import Footer from "./component/Footer";
import StoryofWaste from "./component/AboutUS/StoryofWaste";
import VisionMission from "./component/AboutUS/VisionMission";
import DoortoDoor from "./component/Products/DoortoDoor";
import Weighbridge from "./component/Products/Weighbridge";
import BinMonitoring from "./component/Products/BinMonitoring";
import VehicleMonitoring from "./component/Products/VehicleMonitoring";
import EmployeeManagement from "./component/Products/EmployeeManagement";
import AIWasteManagement from "./component/Products/AIWasteManagement";
import SwachhAJV from "./component/Platform/SwachhAJV";
import CaseStudies from "./component/Resources/CaseStudies";
import Datasheet from "./component/Resources/Datasheet";
import Videos from "./component/Resources/Videos";
import Brochure from "./component/Resources/Brochure";
import Gallery from "./component/Resources/Gallery";
import Blogs from "./component/Resources/Blogs";
import Podcast from "./component/Resources/Podcast";
import SwachhAJVShop from "./component/Resources/SwachhAJVShop";
import SmartBins from "./component/Resources/AllBlogs/SmartBins";
import AIWasteSegregation from "./component/Resources/AllBlogs/AIWasteSegregation";
import WasteManagementPolicy from "./component/Resources/AllBlogs/WasteManagementPolicy";
import DigitalWasteTracking from "./component/Resources/AllBlogs/DigitalWasteTracking";
import AutomatedWasteSorting from "./component/Resources/AllBlogs/AutomatedWasteSorting";
import OfferingGeoTrackingVehicles from "./component/Resources/AllBlogs/OfferingGeoTrackingVehicles";
import OfferingSmartSegregation from "./component/Resources/AllBlogs/OfferingSmartSegregation";
import OfferingGrievanceRedressal from "./component/Resources/AllBlogs/OfferingGrievanceRedressal";
import OfferingDataDrivenInsights from "./component/Resources/AllBlogs/OfferingDataDrivenInsights";
import OfferingRouteOptimization from "./component/Resources/AllBlogs/OfferingRouteOptimization";
import CaseStudyChennai from "./component/Resources/AllBlogs/CaseStudyChennai";
import CaseStudyAligarh from "./component/Resources/AllBlogs/CaseStudyAligarh";
import CaseStudyJammu from "./component/Resources/AllBlogs/CaseStudyJammu";
import CaseStudyTelangana from "./component/Resources/AllBlogs/CaseStudyTelangana";
import CaseStudyPrivateTownShip from "./component/Resources/AllBlogs/CaseStudyPrivateTownShip";
import Register from "./component/Register";
import Checkout from "./component/Checkout";
import OrderSummary from "./component/OrderSummary";
import OrderSuccess from "./component/OrderSuccess";
import TermsConditions from "./component/TermsConditions";
import PrivacyPolicy from "./component/PrivacyPolicy";
import BlogDetail from "./component/Resources/BlogDetail";
import CaseStudyDetail from "./component/Resources/CaseStudyDetail";
import BrochureDetail from "./component/Resources/BrochureDetail";

function App() {
  return (
    <CartProvider>
      <Router>
        <Routes>
          {/* Special route for signin without layout */}
          <Route path="/signin" element={<SignIn />} />
          <Route path="/register" element={<Register />} />
          <Route path="/order-success" element={<OrderSuccess />} />

          {/* All other routes with layout */}
          <Route
            path="*"
            element={
              <>
                {/* <Toaster
                  position="top-center"
                  toastOptions={{
                    style: {
                      zIndex: 100000, // Higher than modal's z-index
                      fontSize: "14px",
                      maxWidth: "500px",
                    },
                  }}
                /> */}
                <Navbar />
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/story-of-waste" element={<StoryofWaste />} />
                  <Route path="/vision-mission" element={<VisionMission />} />
                  <Route
                    path="/door-to-door-collection"
                    element={<DoortoDoor />}
                  />
                  <Route path="/weighbridge" element={<Weighbridge />} />
                  <Route path="/bin-monitoring" element={<BinMonitoring />} />
                  <Route
                    path="/vehicle-monitoring"
                    element={<VehicleMonitoring />}
                  />
                  <Route
                    path="/employee-management"
                    element={<EmployeeManagement />}
                  />
                  <Route
                    path="/ai-waste-management"
                    element={<AIWasteManagement />}
                  />
                  <Route path="/swachhajv" element={<SwachhAJV />} />
                  <Route path="/case-studies" element={<CaseStudies />} />
                  <Route path="/datasheet" element={<Datasheet />} />
                  <Route path="/videos" element={<Videos />} />
                  <Route path="/brochure" element={<Brochure />} />
                  <Route path="/gallery" element={<Gallery />} />
                  <Route path="/blogs" element={<Blogs />} />
                  <Route path="/podcast" element={<Podcast />} />
                  <Route path="/shop" element={<SwachhAJVShop />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/cart" element={<Cart />} />

                  <Route
                    path="/blog/how-iot-is-revolutionizing-waste-collection"
                    element={<SmartBins />}
                  />

                  <Route
                    path="/blog/aipowered-waste-segregation-explained"
                    element={<AIWasteSegregation />}
                  />
                  <Route
                    path="/blog/policy-changes-shaping-waste-management"
                    element={<WasteManagementPolicy />}
                  />
                  {/* Slug using "useParams" Dynamic Page Rendering*/}
                  <Route path="/blog/:slug" element={<BlogDetail />} />
                  <Route path="/case-study/:slug" element={<CaseStudyDetail />} />
                  <Route path="/brochure/:slug" element={<BrochureDetail />} />

                  <Route
                    path="/blog/tracking-waste-digitally"
                    element={<DigitalWasteTracking />}
                  />
                  <Route
                    path="/blog/automation-in-waste-sorting"
                    element={<AutomatedWasteSorting />}
                  />  
                  <Route
                    path="/geo-tracking"
                    element={<OfferingGeoTrackingVehicles />}
                  />
                  <Route
                    path="/smart-segregation"
                    element={<OfferingSmartSegregation />}
                  />
                  <Route
                    path="/grievance-redressal"
                    element={<OfferingGrievanceRedressal />}
                  />
                  <Route
                    path="/data-insights"
                    element={<OfferingDataDrivenInsights />}
                  />
                  <Route
                    path="/route-optimization"
                    element={<OfferingRouteOptimization />}
                  />

                  <Route path="/checkout" element={<Checkout />} />
                  <Route path="/order-summary" element={<OrderSummary />} />
                  
                  <Route path="/termofuse" element={<TermsConditions />} />
                  <Route path="/privacypolicy" element={<PrivacyPolicy />} />
                  {/* <Route path="/case-studies/swachhajv-implementation-in-chennai" element={<CaseStudyChennai />} /> */}
                  {/* <Route path="/case-studies/aligarh-municipal-waste-transformation" element={<CaseStudyAligarh />} /> */}
                  {/* <Route path="/case-studies/jammu-smart-city-pilot-project" element={<CaseStudyJammu />} /> */}
                  {/* <Route path="/case-studies/telangana-ulb-modernization" element={<CaseStudyTelangana />} /> */}
                  {/* <Route path="/case-studies/private-township-implementation" element={<CaseStudyPrivateTownShip />} /> */}
                </Routes>
                <Footer />
              </>
            }
          />
        </Routes>
      </Router>
    </CartProvider>
  );
}

export default App;
